/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does 'KiB' mean, and how is it different from 'KB'?`)
};

const es_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa 'KiB' y cómo es diferente a 'KB'?`)
};

const de_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet 'KiB', und wie unterscheidet es sich von 'KB'?`)
};

const nl_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat betekent 'KiB' en hoe verschilt het van 'KB'?`)
};

const fr_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que 'KiB' signifie, et comment est-il différent de 'KB' ?`)
};

const it_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa 'KiB' e come differisce da 'KB'?`)
};

const pt_br2_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa 'KiB' e como é diferente de 'KB'?`)
};

const pt_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa 'KiB' e como é diferente de 'KB'?`)
};

const ja_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「KiB」は何を意味し、「KB」とどのように異なりますか?`)
};

const zh_uc_data_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq3_q", locale)
	if (locale === "en") return en_uc_data_faq3_q(inputs)
	if (locale === "es") return es_uc_data_faq3_q(inputs)
	if (locale === "de") return de_uc_data_faq3_q(inputs)
	if (locale === "nl") return nl_uc_data_faq3_q(inputs)
	if (locale === "fr") return fr_uc_data_faq3_q(inputs)
	if (locale === "it") return it_uc_data_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq3_q(inputs)
	if (locale === "pt") return pt_uc_data_faq3_q(inputs)
	if (locale === "ja") return ja_uc_data_faq3_q(inputs)
	return zh_uc_data_faq3_q(inputs)
};